import type { CategoryUnionType, CompanyLinkType } from '@api';
import type { RecipientOptionType } from '../../types';

const RECIPIENT_CATEGORIES: CategoryUnionType[] = [
  'TOUR_REP_CALENDAR',
  'SELFPROMOTE_CALENDAR',
];

export const getRecipientOptions = (
  companies: CompanyLinkType[]
): RecipientOptionType[] => {
  const options: RecipientOptionType[] = [];

  companies.forEach(({ contact: { email }, companyName, categories }) => {
    if (!categories.some((category) => RECIPIENT_CATEGORIES.includes(category)))
      return;
    // Mantine Select throws on duplicate values, so keep the first link per email.
    if (!email || options.some((option) => option.value === email)) return;

    options.push({
      value: email,
      label: companyName ? `${email} (${companyName})` : email,
    });
  });

  return options;
};
